import { render, staticRenderFns } from "./PairedInputs.vue?vue&type=template&id=14132832&"
import script from "./PairedInputs.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PairedInputs.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports